import React, { useContext, useState } from "react";
import {
  Popover,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Grid,
  Box,
  IconButton,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";
import AppConfig from "../config";
const { AuthContext } = require("../contexts/AuthContext");

const FilterModal = ({
  setAnchorEl,
  anchorEl,
  filters,
  setFilters,
  handleRemoveFilter,
  handleApply,
  handleClose,
}) => {
  const handleAddFilter = () => {
    setFilters([...filters, { field: "", action: "", value: "" }]);
  };

  const handleFilterChange = (index, key, value) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const { subsection, setSubsection } = useContext(AuthContext);

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;

  React.useEffect(() => {
    // Sync localFilters with filters when the modal opens
    if (open) {
      setFilters(filters);
    }
  }, [open, filters]);

  const handleCloseOutside = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseOutside}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ padding: 2, width: { lg: 650, sm: 650 } }}>
          <Typography variant="h6" component="div" textAlign="center">
            Apply Filters
          </Typography>
          {filters?.map((filter, index) => (
            <Grid
              container
              spacing={2}
              alignItems="center"
              key={index}
              sx={{ marginBottom: 2 }}
            >
              <Grid item xs={12} sm={4}>
                <FormControl fullWidth size="small">
                  <InputLabel>Field</InputLabel>
                  <Select
                    label="Field"
                    value={filter.field}
                    onChange={(e) =>
                      handleFilterChange(index, "field", e.target.value)
                    }
                  >
                    {AppConfig?.filterFields?.map((tableHead, index) => {
                      return (
                        <MenuItem key={index} value={tableHead.value}>
                          {tableHead.label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={3}>
                <FormControl fullWidth size="small">
                  <InputLabel>Action</InputLabel>
                  <Select
                    label="Action"
                    value={filter.action}
                    onChange={(e) =>
                      handleFilterChange(index, "action", e.target.value)
                    }
                  >
                    {AppConfig?.filterActionList?.map((action, index) => {
                      return (
                        <MenuItem key={index} value={action.value}>
                          {action.label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Value"
                  value={filter.value}
                  onChange={(e) =>
                    handleFilterChange(index, "value", e.target.value)
                  }
                  fullWidth
                  size="small" // Reduced input box height
                />
              </Grid>

              {filters.length > 1 && (
                <Grid item xs={12} sm={1}>
                  <IconButton
                    color="error"
                    onClick={() => handleRemoveFilter(index)}
                  >
                    <ClearIcon />
                  </IconButton>
                </Grid>
              )}
            </Grid>
          ))}

          <Box mt={2}>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={handleAddFilter}
              sx={{
                color: AppConfig.colorPalette.text.dark,
                borderColor: AppConfig.colorPalette.primary.main,
              }}
            >
              Add Filter
            </Button>
          </Box>

          <Box
            mt={2}
            display={"flex"}
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent={"space-between"}
          >
            <Button
              onClick={handleClose}
              color="error"
              variant="outlined"
              sx={{ marginBottom: { xs: 1, sm: 0 } }}
            >
              Clear
            </Button>
            <Button
              sx={{
                backgroundColor: AppConfig.colorPalette.primary.main,
              }}
              onClick={handleApply}
              color="primary"
              variant="contained"
            >
              OK
            </Button>
          </Box>
        </Box>
      </Popover>
    </div>
  );
};

export default FilterModal;
